<template>
	<div class="phone_dialog" id="phone_dialog">
		<div class="phone_dialog_title">
			<div class="left">
				<!-- <div class="icon"><font-awesome-icon :icon="['fas', 'phone']" /></div> -->
				<div class="in-call-status icon">
					<img style="width: 21px;height: 21px;" src="../../assets/img/Online.png" slot="reference" />
				</div> 
				<div class="num-text">内線番号: </div>
				<div class="num text-margin-left">{{ $store.state.sysInit.tel_num }}</div>
				<div class="user-name text-margin-left">
					<span>{{this.$store.state.sysInit.user_name}}</span>
				</div>
			</div>
			<div class="title_menu">
				<div class="title_btn" @click="showCallFun(1)">
					<font-awesome-icon :icon="['fas', 'phone']" />
				</div>
				<!-- <div class="title_btn">
					<font-awesome-icon :icon="['fas', 'user-plus']" />
				</div> -->
				<div
					class="title_btn"
					@click="$store.dispatch('phone/setShowPhone', false)"
				>
					<font-awesome-icon :icon="['fas', 'xmark']" />
				</div>
			</div>
		</div>
		<div class="phone_dialog_content">
			<!-- on call html component start -->
			<div class="curLineCollapse" id="curLineCollapse">
				<el-collapse v-model="selectedCurLine" accordion @change="changeCurLine">
					<el-collapse-item v-for="(c, index) in allCallsList" :key="index" :name="c.LineNumber" class="on_call_box">
						<template slot="title">
							<span class="call-title">{{ c.SipSession.isOnHold ? "通話保留中" : (c.SipSession.data.started ? "通話中" : "呼び出し中") }}</span>
							<span> ({{ $utils.computeFullName(c.lastname, c.firstname) }})</span>
						</template>
						<div v-if="c.refreshCustomerInfo" class ="user-infor-loading">
						</div>
						<div class="on_call_info" v-if="!c.refreshCustomerInfo">
							<div class="user_info">
								<div class="avatar">
									<el-avatar :size="70" src="">
										<!-- <img :src="onCallAvatar"/> -->
										<img :src="c.logo_url ? c.logo_url : defaultAvatar" alt="" srcset="">
									</el-avatar>
								</div>
								<div class="name">
									<div>{{ $utils.computeFullName(c.lastname, c.firstname) }}</div>
									<div
										class="t_num"
										v-if="
											c.SipSession.incomingInviteRequest &&
												c.SipSession.incomingInviteRequest.message.headers
													.Tnumber &&
												c.SipSession.incomingInviteRequest.message.headers
													.Tnumber.length &&
												c.SipSession.incomingInviteRequest.message.headers
													.Tnumber[0].raw
										"
									>
										{{ c.LineNumber }}から転送
									</div>
								</div>
							</div>
							<!-- <div class="call_info">
								<div class="call_num">
									{{
										c.SipSession.incomingInviteRequest &&
										c.SipSession.incomingInviteRequest.message.headers
											.Tnumber &&
										c.SipSession.incomingInviteRequest.message.headers.Tnumber
											.length &&
										c.SipSession.incomingInviteRequest.message.headers
											.Tnumber[0].raw
											? $utils.asteriskHeaderArray2Json(
													c.SipSession.incomingInviteRequest.message.headers
														.Tnumber[0].raw
											).tnum
											: c.LineNumber
									}}
								</div>
								<div class="call_time">{{ c.SipSession.data.callTime }}</div>
							</div> -->
							<div class ="call_info">
								<div class = "address">
									{{c.address}}
								</div>
								<div class="call_num">
									{{
										c.SipSession.incomingInviteRequest &&
										c.SipSession.incomingInviteRequest.message.headers
											.Tnumber &&
										c.SipSession.incomingInviteRequest.message.headers.Tnumber
											.length &&
										c.SipSession.incomingInviteRequest.message.headers
											.Tnumber[0].raw
											? $utils.asteriskHeaderArray2Json(
													c.SipSession.incomingInviteRequest.message.headers
														.Tnumber[0].raw
											).tnum
											: c.LineNumber
									}}
								</div>
								<div class="email">
									{{c.email}}
								</div>
								<div class="call_time">{{ c.SipSession.data.callTime }}</div>
							</div>
						</div>
						<div class="on_call_btns">
							<div
								:class="{
									call_btn: true,
									cancel: btn.key == 'cancel',
									green_background: ['transfer','addCall','startCall'].indexOf(btn.key)>-1,
									ac: checkBtnAct(btn.key, c),
									disabled: checkBtnDisabled(btn,c),
								}"
								v-for="btn in btnList"
								:key="btn.key"
							>
								<div
									:class="{
										btn_item: true,
										disabled:checkBtnDisabled(btn,c),
									}"
									@click="clickCallBtn(btn.key, c)"
									:disabled="checkBtnDisabled(btn,c)"
								>
									<div class="icon">
										<font-awesome-icon v-if="btn.key != 'keyboard' && btn.key != 'addCall'"
											:icon="
												checkBtnAct(btn.key, c) && btn.actIcon ? btn.actIcon : btn.icon
											"
										/>
										<icon :name="btn.icon" v-if="['keyboard','addCall'].indexOf(btn.key)>-1"></icon>
									</div>
									<div class="button-label">
										{{
											checkBtnAct(btn.key, c) && btn.actLabel
												? btn.actLabel
												: btn.label
										}}
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
			<!-- on call html component end -->
			<!-- search call no. input component start -->
			<!-- 检索联络先和通话履历 -->
			<el-input
				placeholder=""
				prefix-icon="el-icon-search"
				v-model.trim="searchText"
				size="small"
				clearable
				v-if="!showCall && !showSetting"
				@input="searchContacts" 
			>
			</el-input>
			<!-- search call no. input component end -->
			<!-- in bound calls component start -->
			<div class="calls_box" v-if="callsList.length > 0" id="inbound">
				<Inbound
					:callsList="callsList"
					:lang="sipLang"
					@updateCallNum="updateCallNum"
				></Inbound>
			</div>
			<!-- in bound calls component end -->
			<!-- transfer call component start -->
			<div
				class="transfer_box"
				v-if="
					curLine &&
						curLine.SipSession.data.transfer &&
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'progress'
						).length
				"
			>
				<Transfer
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'progress'
						)
					"
					type="1"
					@transferFun="transferFun"
				></Transfer>
			</div>
			<!-- transfer call component end -->
			<!-- transfer call in progress component start -->
			<div
				class="transfer_box"
				v-if="
					curLine &&
						curLine.SipSession.data.transfer &&
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'accepted' && d.accept.complete == null
						).length
				"
			>
				<Transfer
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.transfer.filter(
							(d) => d.disposition == 'accepted' && d.accept.complete == null
						)
					"
					type="0"
					@transferFun="transferFun"
				></Transfer>
			</div>
			<!-- transfer call in progress component end -->
			<!-- conference call component start -->
			<div
				class="conference_box"
				v-if="
					curLine &&
						curLine.SipSession.data.confcalls &&
						curLine.SipSession.data.confcalls.filter(
							(d) => d.disposition == 'progress'
						).length
				"
			>
				<Conference
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.confcalls.filter(
							(d) => d.disposition == 'progress'
						)
					"
					type="1"
					@conferFun="conferFun"
				></Conference>
			</div>
			<!-- conference call component end -->
			<!-- conference call in progress component start -->
			<div
				class="conference_box"
				v-if="
					curLine &&
						curLine.SipSession.data.confcalls &&
						curLine.SipSession.data.confcalls.filter(
							(d) =>
								d.disposition == 'accepted' &&
								d.accept.complete == null &&
								d.accept.disposition != 'bye'
						).length
				"
			>
				<Conference
					:lang="sipLang"
					:callsList="
						curLine.SipSession.data.confcalls.filter(
							(d) =>
								d.disposition == 'accepted' &&
								d.accept.complete == null &&
								d.accept.disposition != 'bye'
						)
					"
					type="0"
					@conferFun="conferFun"
				></Conference>
			</div>
			<!-- conference call in progress component end -->
			<!-- call history component start -->
			<div :class="curLine ? 'buddies_list cl' : 'buddies_list'" v-if="!showCall && !showSetting">
				<el-tabs v-model="activeName" stretch>
					<el-tab-pane label="外線連絡先" name="ExternalContacts">
						<Contacts ref="externalContactRef" :searchText="searchText" @createCall="createCall" type="external" :active=" activeName == 'ExternalContacts' && showPhone"/>
					</el-tab-pane>
					<el-tab-pane label="内線連絡先" name="InternalContacts">
						<Contacts ref="internalContactRef" :searchText="searchText" @createCall="createCall" type="internal" :active=" activeName == 'InternalContacts' && showPhone"/>
					</el-tab-pane>
					<el-tab-pane label="通話履歴" name="Recent"
						><BuddiesList
							:searchText="searchText"
							:BuddiesList="$store.state.phone.buddiesList"
							@showDetail="showBuddieDetail"
						></BuddiesList
					></el-tab-pane>
				</el-tabs>
			</div>
			<!-- call history component end -->
			<!-- buddie detail component start -->
			<div class="buddie_box" v-if="showBuddieDtl">
				<BuddieDetail
					:buddieDtl="buddieDtl"
					:user="showBuddieDetailUser"
					@closeBuddieDetail="closeBuddieDetail"
					@createCall="createCall"
				></BuddieDetail>
			</div>
			<!-- buddie detail component end -->
			<!-- call phone component start -->
			<div class="call_box" v-if="showCall">
				<Keyboards
				  ref="keyboardsRef"
					@createCall="createCall"
					:showCallBtn="showCallBtn"
					@sendDTMF="sendDTMF"
					@callTransfer="callTransfer"
					@addCall="createConference"
					:callStatus="callStatus"
				></Keyboards>
			</div>
			<!-- call phone component end -->
			<!-- phone setting component start --> 
			<div class="phone-setting" v-if="showSetting">
				<Settings></Settings>
			</div>	
			<!-- phone setting component end --> 
		</div>
	</div>
</template>

<script>
import Keyboards from "@/components/phone/Keyboards.vue";
import { btnList } from "./callBtns";
import Inbound from "@/components/phone/Inbound.vue";
import BuddiesList from "@/components/phone/BuddiesList.vue";
import BuddieDetail from "@/components/phone/BuddieDetail.vue";
import Transfer from "./Transfer.vue";
import Conference from "./Conference.vue";
import Contacts from "./Contacts.vue";
import Settings from "./Settings.vue";
import default_photo from '@/assets/img/user_logo.png'
export default {
	name: "phone",
	components: {
		Keyboards,
		Inbound,
		BuddiesList,
		BuddieDetail,
		Transfer,
		Conference,
		Contacts,
		Settings,
	},
	computed: {
		callsList() {
			return this.$store.state.phone.lineList.filter(
				(line) => line.SipSession.data.calldirection == "inbound" && !line.SipSession.data.started
			);
		},
		allCallsList() {
			return this.$store.state.phone.lineList.filter(e => (e.SipSession.data.calldirection == "inbound" && e.SipSession.data.started) || e.SipSession.data.calldirection == "outbound" ).map(e => ({ ...e, ...this.$store.state.phone.callList.find(d => d.telnum == e.LineNumber) }))
		},
		curLine() {
			return this.$store.state.phone.lineList.find(
				(line) => line.LineNumber == this.$store.state.phone.currentCallerNum
			);
		},
		buddieDtl() {
			return this.curBuddieUid
				? JSON.parse(localStorage.getItem(`${this.curBuddieUid}-stream`))
				: {};
		},
		sipLang() {
			return this.$SIP.getLangText();
		},
		// onCallAvatar() {
		// 	let avatarSrc =
		// 		"https://aicc-dev-documents.s3.jp-tok.cloud-object-storage.appdomain.cloud/profile/default_guest_1692926844546.png";
		// 	if(this.$store.state.phone.onCallInfo.logo_url){
		// 		avatarSrc = this.$store.state.phone.onCallInfo.logo_url;
		// 	}
		// 	return avatarSrc;
		// },
		defaultAvatar() {
			// return process.env.VUE_APP_DEFAULT_PROFILE_PHOTO
			   return default_photo;
		},	
		// onCallUserName() {
		// 	let userName = '';
		// 	if(this.$store.state.phone.onCallInfo.firstname || this.$store.state.phone.onCallInfo.lastname){
		// 		userName = this.$store.state.phone.onCallInfo.lastname + this.$store.state.phone.onCallInfo.firstname;
		// 		this.callsObj[this.$store.state.phone.currentCallerNum] = userName;
		// 	}
		// 	return userName;
		// },
		showPhone() {
			return this.$store.state.phone.showPhone;
		},
	},
	watch: {
		curLine(newVal) {
			if (!newVal)
				(this.callNum = ""),
					this.$store.dispatch("phone/setOnCallInfo", ""),
					this.$store.commit("phone/setCurrentCallerNum", "");
			if (
				this.curLine &&
				this.curLine.SipSession.data.transfer &&
				this.curLine.SipSession.data.transfer.filter(
					(d) => d.disposition == "accepted" && d.accept.complete == null
				).length
			) {
				this.transferFun(0, true)
			}
		},
		"$store.state.phone.currentCallerNum": function(currentCallerNum) {
			if (currentCallerNum) {
				this.callNum = currentCallerNum;
				this.selectedCurLine = currentCallerNum;
			}
		},
	},
	data() {
		return {
			searchText: "",
			activeName: "ExternalContacts",
			showCall: false,
			showCallBtn: true,
			callNum: "",
			btnList: [],
			actBtnList: [],
			showBuddieDtl: false,
			curBuddieUid: "",
			// callsList: []
			callStatus: false,
			selectedCurLine: 0,
			showBuddieDetailUser: {},
			callsObj: {},
			multiCallFlag: false,
			showSetting:false,
		};
	},
	created() {
		if (this.$store.state.phone.currentCallerNum)
			this.callNum = this.$store.state.phone.currentCallerNum;
		this.btnList = btnList(this.sipLang);
	},
	mounted() {},
	methods: {
		changeCurLine(activeNames) {
			if(activeNames){
				// this.curLine = this.allCallsList.find(e => e.LineNumber == activeNames);
				this.$store.dispatch("phone/setOnCallInfo", activeNames);
				this.$store.commit("phone/setCurrentCallerNum", activeNames);
			}
		},
		// showKeyBoard(key){
		// 	this.showCallBtn = 0;
		// 	// this.showCall = !this.showCall;
		// 	if(key=='setting'){
		// 		this.showCall = false
		// 		this.showSetting = !this.showSetting
		// 	}else{
		// 		this.showSetting = false
		// 		this.showCall = !this.showCall
		// 	}
			
		// },
		showSettings(){
			this.showCall = false
			this.showSetting = !this.showSetting
		},
		showCallFun(flag) {
			/**
			 * flag => {
			 * 	0: DTMF
			 * 	1: create call
			 *  2: transfer
			 * }
			 */

			// if (this.curLine) {
			// 	if (this.curLine.SipSession.transferHold) {
			// 		flag = 2;
			// 	} else if (this.curLine.SipSession.conferenceHold) {
			// 		flag = 3;
			// 	} else {
			// 		flag = 0;
			// 	}
			// }
			this.showSetting = false;
			this.showCallBtn = flag;
			if(this.curLine && this.curLine.SipSession.isOnHold && this.curLine.SipSession.transferHold){
				flag = 2;
			}
			
			this.callStatus = false;
			let inbound = this.$store.state.phone.lineList.filter((line) => {
				return line.SipSession.data.calldirection == "inbound" && line.SipSession.data.started
			});
			if(inbound.length > 0){
				this.callStatus = true;
			}

			this.showCall = !this.showCall;
		},
		checkBtnAct(key, c) {
			switch (key) {
				case "mute":
					return c.SipSession.data.ismute;
				case "hold":
					return c.SipSession.isOnHold || c.SipSession.isPlayHoldMusic;
				case "transfer":
					return (
						c.SipSession.isOnHold &&
						c.SipSession.transferHold
					);
				case "addCall":
					return (
						c.SipSession.isOnHold &&
						c.SipSession.conferenceHold
					);
				default:
					return false;
			}
		},
    checkBtnDisabled(btn,c){
      //  disabled Hold/Unhold button  when play sound
      switch (btn.key) {
        case "hold": return (c.SipSession.isPlayHoldMusic || c.SipSession.isPlayUnHoldMusic);
				case "startCall": return !this.showCall
        default:
					return btn.disabled;
      }
    },
		createCall(callNum) {
			this.$SIP.DialByLine("audio", null, callNum);
			this.callNum = callNum;
			this.$store.commit("phone/setCurrentCallerNum", this.callNum);
			this.showCall = false;
			this.onCall = true;
			this.selectedCurLine = callNum
		},
		clickCallBtn(key, c) {
			this.callNum = c.LineNumber;
			switch (key) {
				case "mute":
					c.SipSession.data.ismute
						? this.$SIP.UnmuteSession(this.callNum)
						: this.$SIP.MuteSession(this.callNum);
					break;
				case "keyboard":
					this.showCallFun(0);
					break;
				case "hold":
					if(c.SipSession.isOnHold){ // unhold
            c.SipSession.isPlayUnHoldMusic = true;
						const unholdList = this.allCallsList.filter(e => !e.SipSession.isOnHold && e.LineNumber != this.callNum && e.SipSession.data.started)
						if(this.allCallsList.length > 1 && this.allCallsList.length == unholdList.length + 1){
							// 如果当前为多方通话，并且另一通通话是没有hold 的状态，需要变成hold 的状态
							unholdList.forEach(call => {
								//this.$SIP.holdSession(call.LineNumber)
								this.$SIP.holdWithPlaySound(this.callNum);
							});
						}
						this.$SIP.unholdSession(this.callNum)
					} else { // hold 
						// this.$SIP.holdSession(this.callNum);
            c.SipSession.isPlayHoldMusic = true;
						this.$SIP.holdWithPlaySound(this.callNum);
					}
					// c.SipSession.isOnHold
					// 	? this.$SIP.unholdSession(this.callNum)
					// 	: this.$SIP.holdSession(this.callNum);
					break;
				case "transfer":
					if (
						c.SipSession.isOnHold &&
						c.SipSession.transferHold
					) {
						this.$SIP.CancelTransferSession(this.callNum);
					} else {
						this.$SIP.StartTransferSession(this.callNum);
						this.showCallFun(2);
					}
					break;
				case "addCall":
					if (
						c.SipSession.isOnHold &&
						c.SipSession.conferenceHold
					) {
						this.$SIP.CancelTransferSession(this.callNum);
					} else {
						this.$SIP.StartConferenceCall(this.callNum);
						this.showCallFun(3);
					}
					this.$SIP.StartConferenceCall(this.callNum);
					console.log(c);
					break;
				case "cancel":
					// if (c.SipSession.isOnHold)
					// 	this.$SIP.unholdSession(this.callNum);
					c.SipSession.data.started
						? this.$SIP.endSession(this.callNum)
						: this.$SIP.cancelSession(this.callNum);
						
					this.onCall = false;
					this.callNum = "";
					break;
				case"setting":
					this.showSettings();
				  break;
				case"startCall":
				  this.startCallFn();
					break;
			}
			// if (key == "cancel") {
			// 	this.actBtnList = [];
			// } else {
			// 	if (key != "keyboard") {
			// 		this.actBtnList.includes(key)
			// 			? (this.actBtnList = this.actBtnList.filter((b) => b != key))
			// 			: this.actBtnList.push(key);
			// 	}
			// }
		},
		updateCallNum(callNum) {
			this.callNum = callNum;
			this.selectedCurLine = callNum;
		},
		showBuddieDetail(buddie, user) {
			this.curBuddieUid = buddie.identity;
			this.showBuddieDtl = true;
			this.showBuddieDetailUser = user;
		},
		closeBuddieDetail() {
			this.curBuddieUid = "";
			this.showBuddieDtl = false;
		},
		sendDTMF(num) {
			this.$SIP.sendDTMF(this.callNum, num);
		},
		callTransfer(flag, num) {
			// flag : true => BlindTransfer ; false => AttendedTransfer
			if (flag) {
				this.$SIP.BlindTransfer(this.callNum, num);
			} else {
				this.$SIP.AttendedTransfer(this.callNum, num);
			}
			this.showCall = false;
		},
		transferFun(type, flag) {
			// type : 0 => accepted / 1 => porgress
			// flag : true => complete / false => cancel or terminate
			if (type == 0) {
				flag
					? this.$SIP.transferOnComplete(this.callNum)
					: this.$SIP.transferOnTerminate(this.callNum);
			} else {
				this.$SIP.transferOnCancel(this.callNum);
			}
		},
		createConference(num) {
			this.$SIP.ConferenceDial(this.callNum, num);
			this.showCall = false;
		},
		conferFun(type, flag) {
			// type : 0 => accepted / 1 => porgress
			// flag : true => complete / false => cancel or terminate
			if (type == 0) {
				flag
					? this.$SIP.conferenceOnComplete(this.callNum)
					: this.$SIP.conferenceOnTerminate(this.callNum);
			} else {
				this.$SIP.conferenceOnCancel(this.callNum);
			}
		},
		startCallFn(){
			console.log('phone vue... startCallFn')
			this.$refs.keyboardsRef.startCallFn()
		},
		searchContacts: _.debounce(function () { 
			this.$refs.externalContactRef.searchContacts(); 
			this.$refs.internalContactRef.searchContacts(); 
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.call-title{
	padding-left: 5px;
}
.phone_dialog {
	padding: 15px 10px;
	height: 100%;
	overflow-y: hidden;
}
// title
.phone_dialog_title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	.icon {
		width: 22px;
		height: 22px;
		color: #fff;
		// background: #0653bf;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 5px;
	}
	.title_menu,
	.left {
		display: flex;
		align-items: center;
	}
	.left {
		.icon {
			margin-right: 10px;
		}
	}
	.title_menu {
		.title_btn + .title_btn {
			margin-left: 15px;
		}
		.title_btn {
			cursor: pointer;
		}
	}
	.text-margin-left{
		margin-left: 12px;
	}
}

// phone_dialog_content
.phone_dialog_content {
	height: calc(100% - 30px);
	position: relative;
	// overflow: hidden;
	overflow-y: auto;
	.user-infor-loading{
		height: 125px;
		text-align: center;
		background: white url("../../assets/img/moppy.gif") center center/32px no-repeat;
  	width: 100%;
    top: 0px;
	}
	.buddie_box {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 3;
		height: 100%;
		width: 100%;
		background: #fff;
	}
	.call_box {
		z-index: 4;
		width: 100%;
		background: #fff;
	}
	.on_call_box {
		background: #eff5f8;
		margin: 5px;
		margin-bottom: 15px;
		box-shadow: 0px 1px 3px 2px rgba(167, 192, 202, 0.25);
		::v-deep .el-collapse-item__content{
			padding-bottom: 4px;
		}
		.on_call_title {
			font-weight: bold;
			margin: 10px 0 15px;
		}
		.on_call_info {
			// background: #303950;
			background: #0d0c0c;
			margin: 0 5px;
			padding: 12px 16px;
			border-radius: 8px;
			display: flex;
			color: #fff;
			.user_info {
				width: 90px;
				margin-right: 24px;
				.avatar {
					display: flex;
					justify-content: center;
				}
				.name {
					line-height: 20px;
					font-size: 14px;
					white-space: nowrap;
					text-align: center;
					margin-top: 8px;
					.t_num {
						margin-top: 5px;
						font-size: 12px;
					}
				}
			}
			.call_info {
				// font-size: 16px;
				.call_time {
					// margin: 15px 0;
					color: #4db1ec;
				}
			}
		}
		.on_call_btns {
			display: flex;
			align-items: center;
			justify-content: space-around;
			flex-wrap: wrap;
			padding-bottom: 10px;
			.call_btn {
				width: 20%;
				// padding-bottom: 20%;
				padding-bottom: 18%;
				border-radius: 8px;
				// background: #303950;
				background: #0d0c0c;
				position: relative;
				color: #fff;
				margin: 8px 2% 0;
				overflow: hidden;
				&.cancel {
					background: #c80000;
					.btn_item {
						&:active {
							background: #ca2b2b;
							outline: none;
						}
						&:hover{
							background: rgb(200, 0, 0,0.7);
							outline: none;		
						}
						.icon {
							transform: rotateZ(135deg);
							position: relative;
							top: 5px;
							// transform: ;
							[class*="fa-"] {
								font-size: 20px !important;
							}
						}
					}
				}
				&.green_background {
					background: #34a84f;
					.btn_item {
						&:active {
							background: rgb(52, 168, 79);
							outline: none;
						}
						&:hover{
							background:rgba(52, 168, 79,0.7)
						}
						&.disabled {
						background-color: rgb(52, 168, 79,0.7);
						pointer-events: none;
					}
					}
				}
				.btn_item {
					user-select: none;
					-moz-user-select: none;
					-webkit-user-select: none;
					cursor: pointer;
					position: absolute;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-flow: column;
					.icon {
						margin-bottom: 4px;
						font-size: 20px;
						line-height: 20px;
						display: flex;
						[class*="fa-"] {
							font-size: 20px;
							width: auto;
						}
					}
					// .icon{
					// 		font-size: 24px;
					// 		line-height: 24px;
					// 		display: flex;
					// 	}
					.button-label{
						font-size: 10px;
					}
					p {
						font-size: 13px;
					}
					&.disabled {
						background-color: rgb(13,12,12,0.7);
						pointer-events: none;
					}
				}
				&:active,
				&:hover {
					background: rgb(13, 12, 12, 0.7);;
					outline: none;
				}
				&.disabled {
					cursor:not-allowed;
				}
				&.ac {
					// background: #566280;
					outline: none;
				}
			}
		}
	}
	.buddies_list {
		// height: calc(100% - 35px);
		&.cl {
			// height: calc(100% - 400px - 35px);
			min-height: 100px;
		}
		::v-deep .el-tabs__item {
			padding: 0 10px;
		}
	}

	::v-deep .el-tab-pane {
		height: calc(100% - 45px);
		overflow-y: auto;
	}
}
</style>
